var exports = {
  "Q": "xfb577c5e--4dba39--content",
};

module.exports = exports;
